import { combineReducers } from "redux";
import DemoArticleReducer from "./DemoArticleReducer";
import DemoListReducer from "./DemoListReducer";
import CounterReducers from "./CounterReducers";
import LoanReducers from "./LoanReducers";
import UserProfileReducers from "./UserProfileReducers";
import SidebarBackToListReducer from "./DefaultSidebarBackToListReducers";
import IsStaticMasterDataAvailableReducer from "./IsStaticMasterDataAvailableReducer";
import SidebarRefreshReducer from "./SidebarRefreshReducer";
import IsDashboardMenuAvailableReducer from "./IsDashboardMenuAvailableReducer";
import ShowShortcutsReducers from "./ShowShortcutsReducers";

const rootReducer = combineReducers({
  DemoArticleReducer,
  DemoListReducer,
  CounterReducers,
  LoanReducers,
  UserProfileReducers,
  SidebarBackToListReducer,
  IsStaticMasterDataAvailableReducer,
  SidebarRefreshReducer,
  IsDashboardMenuAvailableReducer,
  ShowShortcutsReducers,
});

export default rootReducer;
